import UnlinkIcon from '@/components/icons/UnlinkIcon.vue';
import StrokedTickIcon from '@/components/icons/StrokedTickIcon.vue';
import FlexRow from "@/components/FlexRow.vue";
import AppPopover from "@/components/AppPopover";
import AppIcon from "@/components/AppIcon";
export default {
  name: 'AccountConnectionStatus',
  components: {
    UnlinkIcon,
    StrokedTickIcon,
    FlexRow,
    AppPopover,
    AppIcon
  },
  emits: ['reauthenticate-account'],
  props: {
    status: [String, null]
  }
};